import { render, staticRenderFns } from "./TabBeneficiaryHistoryTimeSheets.vue?vue&type=template&id=5d16c046&"
import script from "./TabBeneficiaryHistoryTimeSheets.vue?vue&type=script&lang=js&"
export * from "./TabBeneficiaryHistoryTimeSheets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports